import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { CrmAuthGate } from './CrmAuthGate'
import {PublicBookingPage}from'./PublicBookingPage'
import './styles.css'
import './reactive-call.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {location.pathname.startsWith('/book/')?<PublicBookingPage/>:<CrmAuthGate><App /></CrmAuthGate>}
    </BrowserRouter>
  </React.StrictMode>,
)
